<template>
  <div class="container">
    <div class="d-flex">
      <div class="col-8 space-cards">
          <div class="back-ground-component">
          <div class="back-ground-second-layer">
            <div class="info-box-total-value">
              <div class="line-price"></div>
              <p class="money-symbol"><strong>R$</strong></p>
              <p class="p-value">
                <strong> {{ plans.value }} </strong>
              </p>
              <p class="p-month">/mês</p>
            </div>
            <div class="info-box-promotion-value">
              <p class="money-symbol"><strong>R$</strong></p>
              <p class="p-value">
                <strong>{{ plans.valuePromotion }}</strong>
              </p>
              <p class="p-month">/mês</p>
            </div>
            <div class="promotion-description">
              <p><strong>Valor promocional</strong></p>
            </div>
            <div>
              <div class="center-text p-color">
                <p class="p-center">{{ plans.infos.info1 }}</p>
              </div>
              <div class="center-text">
                <p class="p-center p-color1">{{ plans.infos.info2 }}</p>
              </div>
              <div class="center-text p-color">
                <p class="p-center">{{ plans.infos.info3 }}</p>
              </div>
              <div class="center-text">
                <p class="p-center">{{ plans.infos.info4 }}</p>
              </div>
              <div class="center-text p-color">
                <p class="p-center">{{ plans.infos.info5 }}</p>
              </div>
              <div class="center-text">
                <p class="p-center">{{ plans.infos.info6 }}</p>
              </div>
              <div class="center-text p-color">
                <p class="p-center">{{ plans.infos.info7 }}</p>
              </div>
            </div>
            <div class="itens"></div>
            <div class="button-plan">
              <button
                class="button-buy-plan form-control"
                type="radio"
                @click="startBilling(plans.plan)"
              >
                Quero Este Plano
              </button>
            </div>
          </div>
          <div class="component-plan-box">
            <p class="text-style">{{ plans.plan }}</p>
          </div>
        </div>
    </div>
    </div>
  </div>
    
</template>

<script>
export default {
  name: "CardsPlansComponent",
  props: {
    plans: Object,
  },
  data() {
    return {
      msg: "selected plan",
      params: {},
    };
  },
  mounted() {
    this.params = JSON.parse(this.$route.params.data);
  },

  methods: {
    startBilling(plan) {
      window.location.href = `/selected-plan-payment/%7B"plano":"${plan}","broker_finance":"${this.params.broker_finance}"%7D`;
    },
  },
};
</script>

<style>
body {
  font-family: "sans-serif";
}

.money-symbol {
  font-size: 20px;
  display: flex;
  align-items: center;
  display: flex;
  align-items: end;
  height: 50px;
}

.line-price {
  width: 50%;
  height: 3px;
  margin-top: 30px;
  background: red;
  position: absolute;
}

.p-value {
  font-size: 45px;
  margin-bottom: 0;
}

.p-month {
  font-size: 20px;
  display: flex;
  align-items: center;
  display: flex;
  align-items: end;
  height: 50px;
}

.p-center {
  font-size: 15px;
  margin-bottom: 5px;
  margin-left: 40px;
}

.p-color {
  background-color: rgba(223, 222, 222, 0.918);
}

.back-ground-component {
  width: 350px;
  height: 510px;
  border-radius: 0 10px;
  background-color: #34a9fc;
  position: relative;
}

.back-ground-component:hover {
  transition: 0.8s;
  scale: 1.03;
  box-shadow: 0 0 1em #00a930;
}

.back-ground-second-layer {
  width: 340px;
  height: 490px;
  border-radius: 0 10px 0 0;
  background-color: rgb(255, 255, 255);
  position: absolute;
  bottom: 0;
  left: 0;
}

.component-plan-box {
  color: white;
  width: 120px;
  height: 50px;
  border-radius: 10px 10px 10px 0;
  position: absolute;
  top: 10px;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: end;
  background: linear-gradient(90deg, #348bfc 20%, #5f5cff 100%);
}

.info-box-total-value {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  height: 50px;
}

.info-box-promotion-value {
  display: flex;
  justify-content: center;
  color: #348bfc;
  height: 50px;
}

.promotion-description {
  display: flex;
  justify-content: center;
  font-size: 14px;
}

.button-plan {
  display: flex;
  justify-content: center;
}

.button-buy-plan {
  background-color: white;
  width: 80%;
  height: 40px;
  border: 2px solid #00a930;
  margin-top: 20px;
}

.button-buy-plan:hover {
  background-color: #00a930;
  color: white;
  transition: 0.4s;
  scale: 1.1;
  box-shadow: 0 0 1em #00a930;
}

@media screen and (max-width: 1200px) {
  .space-cards{
    margin-bottom: 30px;
  }
}
</style>